import React from "react";
import { TextField, Tooltip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import {
  TIME_FILTERS_SAME_DATE_TOOLTIP,
  timeFiltersSameDateTooltipProps,
} from "../../common/timeFiltersSameDateTooltip";
import { useNavigate } from "react-router-dom";

export const StartTimeDropDownAILink = ({
  userFilters,
  setUserFilters,
  showUserDropDown,
  timeFiltersDisabledAILink,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  showUserDropDown: boolean;
  timeFiltersDisabledAILink: boolean;
}) => {
  const navigate = useNavigate();

  const sx = showUserDropDown ? { width: 132 } : { width: 135 };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Tooltip
        title={TIME_FILTERS_SAME_DATE_TOOLTIP}
        disableHoverListener={!timeFiltersDisabledAILink}
        disableFocusListener={!timeFiltersDisabledAILink}
        disableTouchListener={!timeFiltersDisabledAILink}
        {...timeFiltersSameDateTooltipProps}
      >
        <span style={{ display: "inline-block" }}>
          <DesktopTimePicker
            label="Start Time"
            value={userFilters.start_time ? userFilters.start_time : null}
            onChange={(newValue) => {
              setUserFilters((previousState: any) => {
                return { ...previousState, start_time: newValue };
              });
            }}
            disabled={timeFiltersDisabledAILink}
            renderInput={(params) => (
              <TextField {...params} autoComplete="off" sx={sx} />
            )}
          />
        </span>
      </Tooltip>
    </LocalizationProvider>
  );
};
